module.exports = __webpack_public_path__ + "img/优异.94b1576a.png";